import { render, staticRenderFns } from "./go-img.vue?vue&type=template&id=0b2f0ae4&scoped=true"
import script from "./go-img.vue?vue&type=script&lang=js"
export * from "./go-img.vue?vue&type=script&lang=js"
import style0 from "./go-img.vue?vue&type=style&index=0&id=0b2f0ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f0ae4",
  null
  
)

export default component.exports